import { Directive, inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { UiPageChromeService } from './page-chrome.service';

/**
 * Declara el contenido que va bajo la barra de título desde una página.
 * Uso típico: `ui-icon-tab-bar` en vistas de edición.
 *
 * Cuando las pestañas son rutas hijas, la plantilla vive en el componente que
 * hospeda al `router-outlet` de las pestañas, no en cada pestaña.
 *
 * @example
 * ```html
 * <ng-template uiPageBelowTitleBar>
 *   <ui-icon-tab-bar
 *     [tabs]="editTabs"
 *     [activeTab]="activeTab()"
 *     (tabChange)="onTabChange($event)"
 *   />
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[uiPageBelowTitleBar]',
})
export class UiPageBelowTitleBarDirective implements OnInit, OnDestroy {
  private readonly template = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly chrome = inject(UiPageChromeService);

  ngOnInit(): void {
    this.chrome.registerBelowTitleBar(this.template);
  }

  ngOnDestroy(): void {
    this.chrome.releaseBelowTitleBar(this.template);
  }
}
